export default __webpack_public_path__ + "static/media/sticker-J.fdc7d423.png";